import React,{useContext,useEffect,useState} from 'react';
import AuthContext from '../../context/authContext/authContext'
// import FacebookLogin from 'react-facebook-login';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';
import {Link} from 'react-router-dom'
import FastfoodIcon from '@material-ui/icons/Fastfood';
import MuiAlert from '@material-ui/lab/Alert';
import {
    Grid,
    Box,
    Avatar,
    Snackbar,
    Button,
    Paper,
    CssBaseline,
    Typography,
    Backdrop,
    CircularProgress

} from '@material-ui/core';
import { Formik, Field, Form } from 'formik';



function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
      },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    image: {
        backgroundImage: 'url(./logo.png)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
          theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center  top',
      },
    buttom : {
        marginTop:'2rem',
        marginBottom:'1rem'
      
    },
    form :{
        width: '100%'
    },
    facebook : {
        marginTop: '1rem',
        marginBottom: '2rem',
        padding: "6px 16px",
        fontSize: "0.875rem" ,
        minWidth: "64px",
        boxSizing: "border-box",
        textTransform : "uppercase",
        color : '#fff',
        backgroundColor:'#3f51b5',
        textDecoration : 'none',
        boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
        fontWeight: "500",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
        outline : "0"
 

    },
    backdrop : {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    } 

}));



const Login = (props) => {



    const authContext = useContext(AuthContext);
    const { 
        mensaje, 
        error, 
        registrado, 
        autenticado,
        reiniciarErrorMensaje,
        login,
        // facebookLogin,
            } = authContext;

    const [loading, setloading] = useState(false);

    useEffect(() => {
        if(error){
            setloading(false)
        }
        if(autenticado){
            setloading(false)
            
         props.history.push('/admin/salon')
            
        }
        
      
    }, [error, autenticado, props.history]);

    
    const resetMensajeError = () => {
        reiniciarErrorMensaje();
    }

    const handleSubmit = values =>{
        setloading(true);
        login(values);
       
    }

    

    // const responseFacebook = response =>{
    //     setloading(true)
    //     const data = {
    //         nombre : response.name,
    //         email : response.email,
    //         username : response.id,
    //         password : response.id
    //     }
        
    //     facebookLogin(data)
    // }
    
    const style = useStyles();

    const loginSchema = Yup.object().shape({

        username: Yup.string()
            .required("El usuario es requerido")
            .min(6 , "Debe contener al menos 6 caracteres")
            .max(255, "Maximo 255 caracteres"),

        password: Yup.string()
            .required('Debe incluir el password')
            .min(6,'Debe contener al menos 6 caracteres'),

    })
    

    return (
        <Grid container component="main" className={style.root}>
             <Snackbar
                 anchorOrigin={ {vertical: 'top', horizontal: 'center'} }
                 open={registrado}
                 autoHideDuration={6000}
                 onClose = {resetMensajeError}
                
             >  
                 <Alert  severity="success">
                    {mensaje}
                </Alert>

             </Snackbar>
             <Snackbar
                 anchorOrigin={ {vertical: 'top', horizontal: 'center'} }
                 open={error}
                 autoHideDuration={6000}
                 onClose = {resetMensajeError}
             >  
                 <Alert  severity="error">
                    {mensaje}
                </Alert>

             </Snackbar>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={style.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={style.paper}>
                    <Avatar className={style.avatar}>
                        <FastfoodIcon />
                    </Avatar>
                    <Typography component="h1" variant="h4">
                        Pila Cerveceria
                    </Typography>
                    <Typography component="h2" variant="h5">
                        Iniciar Sesion
                    </Typography>
                    <Formik
                        initialValues={{
                            username: '',
                            password: ''
                        }}
                        validationSchema={loginSchema}
                        onSubmit={async (values, {resetForm }) => {
                            handleSubmit(values);
                            resetForm({values:''});
                            
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Grid > 
                                <Form className={style.form}>
                                   <Box xs={12}><Field type="string" name="username" component={TextField} label='Username' /></Box>
                                   <Box xs={12}><Field type="password" name="password" component={TextField} label='Password' /></Box>
                                   
                                   <Box xs={12} style={{
                                                    textAlign:'center' 
                                    }} >
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            className={style.buttom}
                                        >
                                        Ingresar
                                        </Button>
                                    </Box>
                              
                                </Form>

                            </Grid>
                            
                        )}
                    </Formik>
                  
                     {/* <Typography>o</Typography>
                                 
                            <FacebookLogin
                                appId="2574726402838147"
                              
                                fields="name,email,picture"
                                onclick={facebookLogin}
                                callback={responseFacebook}
                                textButton = 'Ingresar con Facebook'
                                cssClass = {style.facebook}
                            /> */}
                   
                    <Grid container justify='space-around' >
                        <Grid item >
                        
                        </Grid>
                        <Grid item>
                            {/* <Link to={'/signUp'} variant="body2">
                                Crear Cuenta
                            </Link> */}
                        </Grid>
                    </Grid>
                    <Box mt={5}>
                        <Typography variant="body2" color="textSecondary" align="center">
                            {'Copyright © '}
                        <Link to={'/'} color="inherit" href="#">
                                Pila Cerveceria 
                        </Link>{' '}{new Date().getFullYear()}{'.'}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" align="center">
                                Powered By AguileraWebDeveloper
                        </Typography>
                    </Box>
           
          </div>
        </Grid>
        <Backdrop className={style.backdrop} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
      </Grid >
    
     
     );
}

export default Login;